"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var empty_link_analytics_graphic_svg_1 = __importDefault(require("@assets/components/user/drawer/empty-link-analytics-graphic.svg"));
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        emptyLinkAnalyticsGraphic: {
            marginTop: '24px',
            position: 'relative',
            zIndex: -1,
        },
        emptyLinkAnalyticsBodyText: {
            marginTop: '27px',
            textAlign: 'center',
            padding: '10px',
        },
    });
});
/**
 * @component Default display component in place of search result.
 */
var NoLinkAnalyticsGraphic = function () {
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("div", { className: classes.emptyLinkAnalyticsGraphic },
            react_1.default.createElement("img", { src: empty_link_analytics_graphic_svg_1.default, alt: "empty link analytics graphic" })),
        react_1.default.createElement(core_1.Typography, { variant: "body1", className: classes.emptyLinkAnalyticsBodyText }, "Your link does not have any statistics yet")));
};
exports.default = NoLinkAnalyticsGraphic;
